export default __webpack_public_path__ + "static/media/section2_1.5c6dcd50.png";